import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './allclaims.css'
import { debounce } from 'lodash' // if lodash is available, or implement manual debounce

const ClaimsDisplay = () => {
  const navigate = useNavigate()
  const search_icon = `${process.env.PUBLIC_URL}/custom-icons/search_icon.png`

  const [loading, setLoading] = useState(true)
  const [claimsData, setClaimsData] = useState([])
  const [progressMap, setProgressMap] = useState({})
  const [sortOrder, setSortOrder] = useState('desc') // Default: newest first
  const [search, setSearch] = useState('') // Added search state

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem('insuranceUser'))
          console.log("21",storedUser);
          
      if (!storedUser || !storedUser.userId) {
        console.error('User not logged in')
         alert('User not logged in. Please login again.')
        setClaimsData([])
        return
      }
      
        // const response = await axios.post("/agentApis/claims");
        const response = await axios.post('/agentApis/claims', {
          userId: storedUser.userId
        })
        console.log('22', response.data)
        setClaimsData(response.data || [])
        localStorage.setItem('claimsData', JSON.stringify(response.data))
      } catch (error) {
        console.error('Failed to fetch claims:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchClaims()
  }, [])

  useEffect(() => {
    const fetchAllProgress = async () => {
      try {
        const claimNumbers = claimsData.map(c => c.claimNumber)
        const res = await axios.post('/process_data/claim_progress_bulk', {
          claimNumbers
        })
        console.log('66', res.data)

        setProgressMap(res.data || {})
      } catch (err) {
        console.error('Bulk progress fetch failed', err)
      }
    }
    if (claimsData.length > 0) fetchAllProgress()
  }, [claimsData])

  const getStep = progressData => {
    if (!progressData) return 2
    let step = 2

    if (progressData.survey_doc && progressData.survey_upload) step = 3

    if (step === 3 && progressData.work_app_update) step = 4

    if (
      step === 4 &&
      (progressData.pre_repair_doc || progressData.pre_repair_upload)
    )
      step = 5

    if (
      step === 5 &&
      (progressData.post_repair_doc || progressData.post_repair_upload)
    )
      step = 6

    if (step === 6 && (progressData.invoice || progressData.pre_invoice))
      step = 7

    if (step === 7 && progressData.delivery) step = 9

    return step
  }

  const handleReviewComponent = (e, claim) => {
    navigate(`/review-page/${claim.claimNumber}`, { state: { claim } })
  }

  const handleButtonClick = (e, claim) => {
    e.stopPropagation()
    navigate(`/claimLanding/${claim.claimNumber}`, { state: { claim } })
  }

  const getStatusText = (stepsCompleted, totalSteps) => {
    if (stepsCompleted === 0) return 'Claim process not started.'
    if (stepsCompleted === totalSteps)
      return 'All steps completed. Claim is ready.'
    return `${stepsCompleted} of ${totalSteps} steps are completed. Finish the steps to complete the claiming process.`
  }

  // Enhanced search filter for claims number, vehicle number, and policy number
  const filteredClaims = claimsData.filter(claim => {
    if (!search.trim()) return true

    const searchTerm = search.toLowerCase()
    return (
      (claim.claimNumber &&
        claim.claimNumber.toLowerCase().includes(searchTerm)) ||
      (claim.vehicle && claim.vehicle.toLowerCase().includes(searchTerm)) ||
      (claim.policyNumber &&
        claim.policyNumber.toLowerCase().includes(searchTerm))
    )
  })
  // yha se sorting kia hu
  //  Parse claimFromState.date in "DD-MM-YYYY HH:mm:ss" format
  const parseDateTime = claim => {
    const dateTimeStr =
      claim.claimFromState?.date ||
      claim.date ||
      claim.createdAt ||
      claim.claimIntimationDate

    if (!dateTimeStr) return new Date(0)

    try {
      // exmple: "29-10-2025 17:11:34" yhi formt h
      const [datePart, timePart] = dateTimeStr.trim().split(' ')
      if (!datePart || !timePart) return new Date(0)

      const [day, month, year] = datePart.split('-').map(Number)
      const [hours, minutes, seconds] = timePart.split(':').map(Number)

      const parsedDate = new Date(year, month - 1, day, hours, minutes, seconds)
      return isNaN(parsedDate) ? new Date(0) : parsedDate
    } catch (e) {
      console.error('Date parse error for:', dateTimeStr, e)
      return new Date(0)
    }
  }

  //  Sort by date + time (Descending — latest first)
  const sortedClaims = [...filteredClaims].sort((a, b) => {
    const dateA = parseDateTime(a)
    const dateB = parseDateTime(b)

    // Latest first
    return dateB - dateA
  })
  return (
    <div className='claims-wrapper'>
      <div className='claims-box'>
        <h2 className='claims-heading'>All Claims</h2>

        {/* Search Container */}
        <div className='search-container-claim'>
          <img
            src={search_icon}
            alt='search icon'
            className='search-icon-claim'
          />
          <input
            type='text'
            placeholder='Search by Claim No, Vehicle No, Policy No'
            className='search-box-claim'
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        {/* Sort Toggle Button with Image */}

        {/* Claims Section */}
        {loading ? (
          <div className='loading-center'>Loading claims...</div>
        ) : (
          <div className='claims-layout'>
            {/* No results message */}
            {sortedClaims.length === 0 && search && (
              <div className='no-results-message'>
                No claims found matching "{search}"
              </div>
            )}

            {sortedClaims.length === 0 && !search && (
              <div className='no-results-message'>No claims available</div>
            )}

            {sortedClaims.map((claim, index) => {
              const progressData = progressMap[claim.claimNumber]
              const currentStep = getStep(progressData)
              const totalSteps = claim.totalSteps || 9

              const percentage = (currentStep / totalSteps) * 100
              const radius = 30
              const circumference = 2 * Math.PI * radius
              const strokeDashoffset =
                circumference - (percentage / 100) * circumference

              return (
                <div
                  key={index}
                  className='claims-item'
                  onClick={e => handleReviewComponent(e, claim)}
                >
                  <div className='claims-info-wrapper'>

  {claim.discrepancies === 'YES' && (
    <div className='discrepancy-badge'>
      found Discrepancies!
    </div>
  )}

  <div className='claims-info'>
    <span>Policy: {claim.policyNumber}</span>
    <span>Vehicle: {claim.vehicle}</span>
  </div>

</div>
                  {/* <div className='claims-info'>
                    <span>Policy: {claim.policyNumber}</span>
                    <span>Vehicle: {claim.vehicle}</span>
                  </div> */}
                  <h3 className='claims-id'>{claim.claimNumber}</h3>

                  <div className='progress-section'>
                    <svg width='60' height='60' viewBox='0 0 80 80'>
                      <circle
                        className='progress-back'
                        cx='40'
                        cy='40'
                        r={radius}
                        strokeWidth='6'
                      />
                      <circle
                        className='progress-front'
                        cx='40'
                        cy='40'
                        r={radius}
                        strokeWidth='6'
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                      />
                      <text
                        x='50%'
                        y='50%'
                        textAnchor='middle'
                        dy='.3em'
                        className='progress-label'
                      >
                        {currentStep}/{totalSteps}
                      </text>
                    </svg>
                    <p className='progress-text'>
                      {getStatusText(currentStep, totalSteps)}
                    </p>
                  </div>

                  <button
                    className='claims-action'
                    onClick={e => handleButtonClick(e, claim)}
                  >
                    Complete Process
                  </button>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ClaimsDisplay
